// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"2d104578","327":"0f5662a5","676":"bd8c08e3","837":"35477d3a"}[chunkId] + ".chunk.js";
};